import { __decorate, __metadata } from "tslib";
import NeoModel from './NeoModel';
import { Observable } from './Decorators';
import { Utils } from '../Utils';
var ObservableValue = /** @class */ (function () {
    function ObservableValue(initialValue) {
        this.value = initialValue;
    }
    Object.defineProperty(ObservableValue.prototype, "peek", {
        get: function () {
            return Utils.peek(this, "value");
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Observable(),
        __metadata("design:type", Object)
    ], ObservableValue.prototype, "value", void 0);
    ObservableValue = __decorate([
        NeoModel,
        __metadata("design:paramtypes", [Object])
    ], ObservableValue);
    return ObservableValue;
}());
export { ObservableValue };
